import MarketingPage from 'vcomponents/marketing/MarketingPage.vue';
import MarketingPreferences from 'vcomponents/marketing/preferences/MarketingPreferences.vue';
import MarketingPreferencesAttributes from 'vcomponents/marketing/preferences/attributes/MarketingPreferencesAttributes.vue';
import MarketingPreferencesCampaigns from 'vcomponents/marketing/preferences/campaigns/MarketingPreferencesCampaigns.vue';

export default [
    {
        path: '/marketing',
        name: 'marketing',
        component: MarketingPage,
        children: [
            {
                path: 'preferences',
                name: 'marketing.preferences',
                component: MarketingPreferences,
                children: [
                    {
                        path: 'attributes',
                        name: 'marketing.preferences.attributes',
                        component: MarketingPreferencesAttributes,
                    },
                    {
                        path: 'consent',
                        name: 'marketing.preferences.consent',
                        component: MarketingPreferencesCampaigns,
                    },
                ],
            },
            {
                path: 'settings',
                name: 'marketing.settings',
                redirect: { name: 'marketing.preferences.attributes' },
            },
        ],
    },
];
